import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private subject: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(public http:HttpClient) { 

  }

  getDashboardApplicationListService(): Observable<any>{
    // return this.http.get(environment.BASE_URL_RPT+'rpt/getDashboardByCommonProfile/false');
    return this.http.get(environment.BASE_URL_PCD+'api/das/dashboard-tracking');
    // return this.http.get('http://10.110.0.137:8081/startup-1.0/api/das/dashboard-tracking');
  }

  getProfileStrength():Observable<any>{
    return this.http.get(environment.BASE_URL_PROFILE+'profile/getProfileStrength');
  }

  getTaskAssignList():Observable<any>{
    return this.http.get(environment.BASE_URL_RPT+'rpt/getTaskTrackingByCommonProfile');
  }

  getValidateProfileData(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'profile/validateProfileData',payload);
  }

  getAnnouncementList():Observable<any>{
    return this.http.get(environment.BASE_URL_RPT+'rpt/getAnnouncementList');
  }

  refreshEducation(appId):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`desAdmin/refreshEducation/${appId}`)
  }

  public isFocalPerson():Observable<any>{
    return this.http.get(environment.BASE_URL_DAS+'das/isForeignEmbassyFocalPerson');
  }

  setAppFormStatus(isSaved: boolean, isSubmitted:boolean) {
    this.subject.next({ isSaved: isSaved, isSubmitted:isSubmitted});
  }

  getAppFormstatus(): Observable<any> {
    return this.subject.asObservable();
  }
  
}
